import { Component, OnInit,Inject } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { StudentService } from '../services/Student.service';
import { GenericVm } from '../../shared/models/system/generic-vm';
import { StudentData } from '../../shared/models/DTO/StudentData';
import { Globals } from '../../shared/services/globals';

@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.css']
})
export class StudentDetailsComponent implements OnInit {
  
  student: StudentData=new StudentData();

  constructor(
   private studentService:StudentService,
   public globals: Globals,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
      this.globals.spinner=true;
    this.studentService.getStudentDetail(this.data.studentId).subscribe(
      res=>{
        this.globals.spinner=false;
        let result= res as GenericVm<StudentData>;
        if(result.status){
          this.student=result.data;
        }
      }
    )
  }

}
